module.exports = __webpack_public_path__ + "img/font_tahoma_2.9bb9500e.svg";